/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationReference } from './OrganizationReference';
import {
    OrganizationReferenceFromJSON,
    OrganizationReferenceFromJSONTyped,
    OrganizationReferenceToJSON,
} from './OrganizationReference';
import type { ServicePackageOptionReference } from './ServicePackageOptionReference';
import {
    ServicePackageOptionReferenceFromJSON,
    ServicePackageOptionReferenceFromJSONTyped,
    ServicePackageOptionReferenceToJSON,
} from './ServicePackageOptionReference';
import type { ServicePackagePlanReference } from './ServicePackagePlanReference';
import {
    ServicePackagePlanReferenceFromJSON,
    ServicePackagePlanReferenceFromJSONTyped,
    ServicePackagePlanReferenceToJSON,
} from './ServicePackagePlanReference';

/**
 * 
 * @export
 * @interface LaundryGroupSubscriptionOverview
 */
export interface LaundryGroupSubscriptionOverview {
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupSubscriptionOverview
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupSubscriptionOverview
     */
    readonly wlNumber: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupSubscriptionOverview
     */
    readonly name: string;
    /**
     * 
     * @type {OrganizationReference}
     * @memberof LaundryGroupSubscriptionOverview
     */
    organization: OrganizationReference;
    /**
     * 
     * @type {ServicePackagePlanReference}
     * @memberof LaundryGroupSubscriptionOverview
     */
    activatedServicePackagePlan: ServicePackagePlanReference;
    /**
     * 
     * @type {Array<ServicePackageOptionReference>}
     * @memberof LaundryGroupSubscriptionOverview
     */
    servicePackagePlanOptions?: Array<ServicePackageOptionReference>;
}

/**
 * Check if a given object implements the LaundryGroupSubscriptionOverview interface.
 */
export function instanceOfLaundryGroupSubscriptionOverview(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "wlNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "organization" in value;
    isInstance = isInstance && "activatedServicePackagePlan" in value;

    return isInstance;
}

export function LaundryGroupSubscriptionOverviewFromJSON(json: any): LaundryGroupSubscriptionOverview {
    return LaundryGroupSubscriptionOverviewFromJSONTyped(json, false);
}

export function LaundryGroupSubscriptionOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupSubscriptionOverview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'wlNumber': json['wlNumber'],
        'name': json['name'],
        'organization': OrganizationReferenceFromJSON(json['organization']),
        'activatedServicePackagePlan': ServicePackagePlanReferenceFromJSON(json['activatedServicePackagePlan']),
        'servicePackagePlanOptions': !exists(json, 'servicePackagePlanOptions') ? undefined : ((json['servicePackagePlanOptions'] as Array<any>).map(ServicePackageOptionReferenceFromJSON)),
    };
}

export function LaundryGroupSubscriptionOverviewToJSON(value?: LaundryGroupSubscriptionOverview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization': OrganizationReferenceToJSON(value.organization),
        'activatedServicePackagePlan': ServicePackagePlanReferenceToJSON(value.activatedServicePackagePlan),
        'servicePackagePlanOptions': value.servicePackagePlanOptions === undefined ? undefined : ((value.servicePackagePlanOptions as Array<any>).map(ServicePackageOptionReferenceToJSON)),
    };
}

